import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EditService from "./Form";
import { FormGroupHeader } from "@/components/shared";
import { ActionButtonConfig } from "@/components/shared/FormGroupHeader";
import { useTranslation } from "react-i18next";
import { useServicePermissionsData } from "@/hooks/cache";
import { ServicePermission } from "@/graphql/__generated__/graphql";
import { EditPermanentServiceModal } from "../../Components";
import { appendOpOrgIdParams } from "@/utils/helpers";

const EditPermanentServiceComponent = () => {

  // Hooks
  const navigate = useNavigate();
  const { t } = useTranslation(["translation", "common"]);
  const { tenderID: currentTenderID, serviceID } = useParams<{ tenderID: string, serviceID: string, operationalOrganizationID: string }>();
  const [searchParams] = useSearchParams();
  const currentOperationalOrganizationID = searchParams.get("operationalOrganizationId");
  const servicePermissionsData = useServicePermissionsData({ serviceID: serviceID as string, type: "Permanent" });

  // Constants
  const userCanEdit = servicePermissionsData?.permissions.includes(ServicePermission.Edit);

  /**
   * OnClick handler for the Back button
   * Constructs the navigation path based on the current mode and requestID.
  */
  const handleBackClick = () => {
    const path = `/tender/${currentTenderID}/services/all${appendOpOrgIdParams(currentOperationalOrganizationID)}`;

    navigate(path);
  };

  // Action buttons for FormGroupHeader
  const actionButtons: ActionButtonConfig[] = [
    {
      text: t("common:buttons.back"),
      actionFn: handleBackClick,
      variant: "outline",
    }
  ].filter(Boolean) as ActionButtonConfig[];

  return (
    <>
      <FormGroupHeader
        actionButtons={actionButtons}
        title={userCanEdit ? t("permanentservice.edittitle") : t("permanentservice.viewtitle")}
        description={`${userCanEdit ? t("permanentservice.edit") : t("permanentservice.view")} ${t("permanentservice.editviewdescription")}`}
        className="pr-4 pl-2"
      >
        <EditPermanentServiceModal />
      </FormGroupHeader>

      <div className="pr-4 pl-2 pb-[300px]">
        <EditService userCanEdit={userCanEdit as boolean} />
      </div>
    </>
  );
};

export default EditPermanentServiceComponent;
